import type { FaireProductEntity } from "../../entity_types/product";

export const p_8e5qgj54en: FaireProductEntity = {
  token: "p_8e5qgj54en",
  type: "product",
  name: "Layered Bead & Gold Chain Necklace",
  brandToken: "b_tstkerjyhp",
  brandName: "Merveille",
  imageUrl:
    "https://cdn.faire.com/fastly/d37070e0cc5b4dfeb3fa0bed612a2000441a77bab3250248991fa63793f8e934.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f98b91d4556051cdbd5321db5f23ef35a01c24e34f161dd972d4fc88f670f06.jpeg",
    "https://cdn.faire.com/fastly/989adf9f027765d2aae9e051d8baee939f42458d2080da820076a2925979fe36.jpeg",
    "https://cdn.faire.com/fastly/b3cc85d2a9b5306b71316f3727d8a2d9bca0810f1708a480119279b1b07a246a.jpeg",
  ],
  priceDollars: 14.2,
  description:
    'Featuring colorful bead strands paired with a chunky gold-tone chain and a delicate drop pendant, this piece delivers effortless statement style.\nPerfect for spring and summer outfits, vacation styling, and boutique statement assortments.\n\nNecklace Length : 16" with 3" Extender\n\nFeatures\n• Layered bead and chain design\n• Mixed texture statement style\n• Gold-tone chain detail\n• Lightweight and easy to style\n• Ideal for boutique and seasonal collections\n\nlayered necklace, beaded chain necklace, gold chain statement necklace, colorful bead necklace, boutique fashion jewelry, trendy layered necklace, women\'s fashion necklace, summer statement necklace, vacation outfit jewelry, mixed texture necklace, boutique accessory necklace, bold fashion necklace, contemporary jewelry necklace, giftable boutique jewelry, stylish statement necklace',
  tags: [],
  msrpDollars: 28.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:47.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
